import axios from 'axios'
import API_URL from '../service/settings'

export const axiosClient = axios.create({ baseURL: API_URL })

const AdminService = {



  updateSignCondition(data) {
    return axiosClient.post('update_sign_condition', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })

  },

  loadGc10SignCondition(sign_no, planet) {
    return axiosClient.get('load_gc10_sign?sign_no=' + sign_no).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },


  saveGc10SignDetail(data) {
    return axiosClient.post('save_gc10_sign_detail', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })

  },

  loadSignCondition(sign, planet, house) {
    return axiosClient.get('load_sign_condition?sign_no=' + sign + '&planet=' + planet + '&house=' + house).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },



  loadSignConditionTalent(sign, planet, houseTalent ,selected_planet_nak_no) {
    return axiosClient.get('load_sign_condition_talent?sign_no=' + sign + '&planet=' + planet + '&house=' + houseTalent+ '&nak=' + selected_planet_nak_no).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },


  saveSignCondition(data) {
    return axiosClient.post('save_sign_condition', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  saveSignConditionTalent(data) {
    return axiosClient.post('save_sign_condition_talent', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  fetchNowMoonDetail(sign) {
    return axiosClient.get('load_now_moon_detail?sign_no=' + sign).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  updateNowMoonDetail(data) {
    return axiosClient.post('save_now_moon_detail', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  fetchNowMoonNakDetail(nak_no) {
    return axiosClient.get('load_now_moon_nak_detail?nak_no=' + nak_no).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  updateNowMoonNakDetail(data) {
    return axiosClient.post('save_now_moon_nak_detail', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  loadSignDetail(sign_id) {
    return axiosClient.get('load_sign_detail?sign_id=' + sign_id).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },



  saveSunSignDetail(data) {
    return axiosClient.post('save_or_update_sun_sign', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })

  },


  saveAKDetail(data) {
    return axiosClient.post('save_or_update_ak_planet', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })

  },


  saveNakAscDetail(data) {
    return axiosClient.post('save_or_update_nak_asc_sign', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })

  },

  saveMahaDashaDetail(data) {
    return axiosClient.post('save_or_update_mahadasha', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })

  },

  saveMoonSignDetail(data) {
    return axiosClient.post('save_or_update_moon_sign', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })

  },

  loadMoonSignDetail(sign_id) {
    return axiosClient.get('load_moon_sign_detail?sign_no=' + sign_id).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },


  loadSunSignDetail(sign_id) {
    return axiosClient.get('load_sun_sign_detail?sign_no=' + sign_id).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  loadMahaDashaDetail(planet) {
    return axiosClient.get('load_mahadasha_detail?planet=' + planet).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  loadNakAscDetail(nak_no) {
    return axiosClient.get('load_nak_asc_detail?nak_no=' + nak_no).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  loadAKDetail(ak_planet) {
    return axiosClient.get('load_ak_planet_detail?ak_planet=' + ak_planet).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  updateNakPlanetCondition(data) {
    return axiosClient.post('save_or_update_nak_planet', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })

  },
  showNakPlanetCondition(planet, nak_no) {
    return axiosClient.get('load_nak_planet_config?planet=' + planet + '&nak_no=' + nak_no).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  fetchAKD(planet, sign) {
    return axiosClient.get('load_akd_detail?planet=' + planet + "&sign=" + sign).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  updateAKD(data) {
    return axiosClient.post('save_or_update_akd_detail', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  fetchDashaDetail(planet, sign, house) {
    return axiosClient.get('load_dasha_detail?planet=' + planet + "&sign=" + sign + "&house=" + house).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  updateDashaDetail(data) {
    return axiosClient.post('save_or_update_dasha_detail', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },


  fetchKarakaDetail(planet, sign, karaka) {
    return axiosClient.get('load_karaka_detail?planet=' + planet + "&sign=" + sign + "&karaka=" + karaka).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  updateKarakaDetail(data) {
    return axiosClient.post('save_or_update_karaka_detail', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },


  fetchRAKEDetail(sign_no) {
    return axiosClient.get('load_rake_detail?sign_no=' + sign_no).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  updateRAKEDetail(data) {
    return axiosClient.post('save_or_update_rake_detail', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },





  // Start Of All Apis For Love



  saveSignConditionLove(data) {
    return axiosClient.post('save_sign_condition_love', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  saveSignConditionLoveTranzitNak(data) {
    return axiosClient.post('save_sign_condition_love_tranzit_nak', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  saveSignConditionLoveTranzitSign(data) {
    return axiosClient.post('save_sign_condition_love_tranzit_sign', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  saveSignConditionLove2(data) {
    return axiosClient.post('save_sign_condition_love2', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },



  loadSignDetailLoveTexts(sign_id) {
    return axiosClient.get('load_sign_detail_love_texts?sign_id=' + sign_id).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  saveSignTextsLove(data) {
    return axiosClient.post('save_sign_texts_love', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  loadSignConditionLove(sign, planet, house) {
    return axiosClient.get('load_sign_condition_love_2?sign_no=' + sign + '&planet=' + planet + '&house=' + house).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },


  loadSignConditionLoveTranzitNak(planet ,selected_planet_nak_no , sign_no) {
    return axiosClient.get('load_sign_condition_love_tranzit_nak?planet=' + planet + '&nak=' + selected_planet_nak_no + '&sign_no=' + sign_no).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  loadSignConditionLoveTranzitSign(planet ,psy_sign_no , psy_sign) {
    return axiosClient.get('load_sign_condition_love_tranzit_sign?planet=' + planet + '&sign_no=' + psy_sign_no + '&sign=' + psy_sign).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  loadSignConditionLoveNinePlanet(planet ,selected_planet_nak_no) {
    return axiosClient.get('load_sign_condition_love?planet=' + planet + '&nak=' + selected_planet_nak_no).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  // End Of All Apis For Love



  // Start Of All Apis For Wealth
  saveSignConditionwealth(data) {
    return axiosClient.post('save_sign_condition_wealth', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  saveSignConditionwealthTranzitNak(data) {
    return axiosClient.post('save_sign_condition_wealth_tranzit_nak', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  saveSignConditionwealthTranzitSign(data) {
    return axiosClient.post('save_sign_condition_wealth_tranzit_sign', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  saveSignConditionwealth2(data) {
    return axiosClient.post('save_sign_condition_wealth2', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },



  loadSignDetailwealthTexts(sign_id) {
    return axiosClient.get('load_sign_detail_wealth_texts?sign_id=' + sign_id).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  saveSignTextswealth(data) {
    return axiosClient.post('save_sign_texts_wealth', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  loadSignConditionwealth(sign, planet, house) {
    return axiosClient.get('load_sign_condition_wealth_2?sign_no=' + sign + '&planet=' + planet + '&house=' + house).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },




  loadSignConditionwealthTranzitNak(planet ,selected_planet_nak_no , sign_no) {
    return axiosClient.get('load_sign_condition_wealth_tranzit_nak?planet=' + planet + '&nak=' + selected_planet_nak_no + '&sign_no=' + sign_no).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  loadSignConditionwealthTranzitSign(planet ,psy_sign_no , psy_sign) {
    return axiosClient.get('load_sign_condition_wealth_tranzit_sign?planet=' + planet + '&sign_no=' + psy_sign_no + '&sign=' + psy_sign).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  loadSignConditionwealthNinePlanet(planet ,selected_planet_nak_no) {
    return axiosClient.get('load_sign_condition_wealth?planet=' + planet + '&nak=' + selected_planet_nak_no).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  // End Of All Apis For Wealth



  // Start Of All Apis For health
  saveSignConditionhealth(data) {
    return axiosClient.post('save_sign_condition_health', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  saveSignConditionhealthTranzitNak(data) {
    return axiosClient.post('save_sign_condition_health_tranzit_nak', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  saveSignConditionhealthTranzitSign(data) {
    return axiosClient.post('save_sign_condition_health_tranzit_sign', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  saveSignConditionhealth2(data) {
    return axiosClient.post('save_sign_condition_health2', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },



  loadSignDetailhealthTexts(sign_id) {
    return axiosClient.get('load_sign_detail_health_texts?sign_id=' + sign_id).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  saveSignTextshealth(data) {
    return axiosClient.post('save_sign_texts_health', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  loadSignConditionhealth(sign, planet, house) {
    return axiosClient.get('load_sign_condition_health_2?sign_no=' + sign + '&planet=' + planet + '&house=' + house).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },


  loadSignConditionhealthTranzitNak(planet ,selected_planet_nak_no , sign_no) {
    return axiosClient.get('load_sign_condition_health_tranzit_nak?planet=' + planet + '&nak=' + selected_planet_nak_no + '&sign_no=' + sign_no).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  loadSignConditionhealthTranzitSign(planet ,psy_sign_no , psy_sign) {
    return axiosClient.get('load_sign_condition_health_tranzit_sign?planet=' + planet + '&sign_no=' + psy_sign_no + '&sign=' + psy_sign).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  loadSignConditionhealthNinePlanet(planet ,selected_planet_nak_no) {
    return axiosClient.get('load_sign_condition_health?planet=' + planet + '&nak=' + selected_planet_nak_no).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  // End Of All Apis For health




  // Start Of All Apis For career
  saveSignConditioncareer(data) {
    return axiosClient.post('save_sign_condition_career', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  saveSignConditioncareerTranzitNak(data) {
    return axiosClient.post('save_sign_condition_career_tranzit_nak', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  saveSignConditioncareerTranzitSign(data) {
    return axiosClient.post('save_sign_condition_career_tranzit_sign', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  saveSignConditioncareer2(data) {
    return axiosClient.post('save_sign_condition_career2', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },



  loadSignDetailcareerTexts(sign_id) {
    return axiosClient.get('load_sign_detail_career_texts?sign_id=' + sign_id).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  saveSignTextscareer(data) {
    return axiosClient.post('save_sign_texts_career', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  loadSignConditioncareer(sign, planet, house) {
    return axiosClient.get('load_sign_condition_career_2?sign_no=' + sign + '&planet=' + planet + '&house=' + house).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },


  loadSignConditioncareerTranzitNak(planet ,selected_planet_nak_no , sign_no) {
    return axiosClient.get('load_sign_condition_career_tranzit_nak?planet=' + planet + '&nak=' + selected_planet_nak_no + '&sign_no=' + sign_no).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  loadSignConditioncareerTranzitSign(planet ,psy_sign_no , psy_sign) {
    return axiosClient.get('load_sign_condition_career_tranzit_sign?planet=' + planet + '&sign_no=' + psy_sign_no + '&sign=' + psy_sign).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  loadSignConditioncareerNinePlanet(planet ,selected_planet_nak_no) {
    return axiosClient.get('load_sign_condition_career?planet=' + planet + '&nak=' + selected_planet_nak_no).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  // End Of All Apis For career






}

export default AdminService
